if (typeof window.__printovaLockBodyScroll !== 'function') {
  window.__printovaLockBodyScroll = function () {
    document.body.style.overflow = 'hidden';
  };
  window.__printovaUnlockBodyScroll = function () {
    document.body.style.overflow = '';
  };
}
var lockBodyScrollPreview = window.__printovaLockBodyScroll;
var unlockBodyScrollPreview = window.__printovaUnlockBodyScroll;

if (!customElements.get('printova-book-preview')) {
  class PrintovaBookPreview extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.cloudName = this.dataset.cloudName || '';
      this.coverUrl = this.dataset.coverUrl || '';
      this.backCoverUrl = this.dataset.backCoverUrl || '';
      this.pageFlip = null;
      this.pages = [];
      this.eagerCount = 5;
      this.resolvedCount = 0;
      this.loaderFaded = false;
      this._lastFocus = null;

      this.innerHTML = `
        <div class="printova-book-preview__backdrop" data-backdrop></div>
        <div class="printova-book-preview__panel" role="dialog" aria-modal="true" aria-labelledby="printova-book-title">
          <header class="printova-book-preview__header">
            <h3 id="printova-book-title">Preview your book</h3>
            <button type="button" class="printova-book-preview__close" data-close aria-label="Close preview">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path fill="currentColor" d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z"/>
              </svg>
            </button>
          </header>
          <div class="printova-book-preview__stage">
            <div class="printova-book-preview__book" data-book></div>
            <div class="printova-book-preview__loader" data-loader>
              <span class="printova-spinner"></span>
              <p>Preparing your book…</p>
            </div>
            <p class="printova-book-preview__warning" data-warning hidden>
              Some pages are still loading. Flip to view them as they become ready.
            </p>
          </div>
          <footer class="printova-book-preview__footer">
            <button type="button" class="printova-book-preview__nav" data-prev aria-label="Previous page">‹</button>
            <p class="printova-book-preview__position" data-position aria-live="polite">Page 1 of 30</p>
            <button type="button" class="printova-book-preview__nav" data-next aria-label="Next page">›</button>
          </footer>
        </div>
      `;

      this.book = this.querySelector('[data-book]');
      this.loader = this.querySelector('[data-loader]');
      this.warning = this.querySelector('[data-warning]');
      this.position = this.querySelector('[data-position]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      this.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.querySelector('[data-backdrop]').addEventListener('click', () => this.close());
      this.prevBtn.addEventListener('click', () => this.pageFlip && this.pageFlip.flipPrev());
      this.nextBtn.addEventListener('click', () => this.pageFlip && this.pageFlip.flipNext());

      this._onKey = (e) => {
        if (!this.hasAttribute('open')) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowLeft' && this.pageFlip) this.pageFlip.flipPrev();
        else if (e.key === 'ArrowRight' && this.pageFlip) this.pageFlip.flipNext();
      };
    }

    open({ photos, cloudName, tripTitle, tripDesc }) {
      if (this._opening || this.pageFlip || this.hasAttribute('open')) {
        console.warn(
          '[printova-book-preview] open() called while already opening/open — ignoring duplicate.'
        );
        return;
      }
      this._opening = true;
      const Lib = window.St && window.St.PageFlip;
      if (!Lib) {
        console.error('[printova] StPageFlip not loaded');
        this._opening = false;
        return;
      }
      this.cloudName = cloudName || this.cloudName;
      this.tripTitle = (tripTitle || '').trim();
      this.tripDesc = (tripDesc || '').trim();
      this._lastFocus = document.activeElement;

      const orderedPhotos = photos.slice();
      this.photoPageCount = orderedPhotos.length;

      const pages = [];
      if (this.coverUrl) {
        pages.push({ type: 'cover', url: this.coverUrl });
      }
      if (orderedPhotos.length > 0) {
        pages.push({
          type: 'opening',
          photo: orderedPhotos[0],
          title: this.tripTitle,
          description: this.tripDesc,
        });
        for (let i = 1; i < orderedPhotos.length; i++) {
          pages.push({ type: 'photo', photo: orderedPhotos[i] });
        }
      }
      if (this.backCoverUrl) {
        pages.push({ type: 'cover-back', url: this.backCoverUrl });
      }
      this.pages = pages;

      this.resolvedCount = 0;
      this.loaderFaded = false;
      this.loader.hidden = false;
      this.loader.style.opacity = '1';
      this.warning.hidden = true;

      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }
      this.setAttribute('open', '');
      lockBodyScrollPreview();
      document.addEventListener('keydown', this._onKey);

      this.renderPages();

      requestAnimationFrame(() => {
        this.initPageFlip(Lib);
      });

      clearTimeout(this._fallbackTimer);
      this._fallbackTimer = setTimeout(() => {
        if (!this.loaderFaded) {
          this.warning.hidden = false;
          this.fadeLoader();
        }
      }, 10000);

      setTimeout(() => this.nextBtn.focus(), 50);
    }

    renderPages() {
      this.book.innerHTML = '';
      this.pageElements = [];
      const total = this.pages.length;

      this.pages.forEach((page, idx) => {
        const pageEl = document.createElement('div');
        pageEl.className = 'printova-book-page';
        pageEl.dataset.pageIndex = String(idx);
        // 'soft' uses clip-path + 2D rotate for the realistic paper-page
        // turn feel. The mid-flip bleed-through of the next page through
        // the unclipped area is an accepted trade-off for the book aesthetic.
        pageEl.dataset.density = 'soft';

        let url = null;
        if (page.type === 'cover' || page.type === 'cover-back') {
          pageEl.classList.add('printova-book-page--cover');
          url = page.url;
          this.fillCoverPage(pageEl);
        } else if (page.type === 'opening') {
          pageEl.classList.add('printova-book-page--opening');
          url = this.cropUrl(page.photo, 700);
          this.fillOpeningPage(pageEl, page.title, page.description);
        } else {
          url = this.cropUrl(page.photo, 900);
          this.fillPhotoPage(pageEl);
        }

        const img = pageEl.querySelector('img');
        if (img) {
          const eager = idx < this.eagerCount;
          if (eager) {
            img.src = url;
            const onResolved = () => {
              this.resolvedCount++;
              if (this.resolvedCount >= Math.min(this.eagerCount, total)) {
                this.fadeLoader();
              }
            };
            img.addEventListener('load', onResolved, { once: true });
            img.addEventListener('error', onResolved, { once: true });
          } else {
            img.dataset.src = url;
            img.loading = 'lazy';
          }
        }

        const label = document.createElement('span');
        label.className = 'printova-book-page__number';
        label.textContent = this.pageLabel(idx);
        pageEl.appendChild(label);

        this.pageElements.push(pageEl);
      });
    }

    fillCoverPage(pageEl) {
      const img = document.createElement('img');
      img.alt = '';
      pageEl.appendChild(img);
    }

    fillPhotoPage(pageEl) {
      const img = document.createElement('img');
      img.alt = '';
      pageEl.appendChild(img);
    }

    fillOpeningPage(pageEl, title, description) {
      // StPageFlip replaces the page element's inline cssText with
      //   "display: block; ...; transform: ...; clip-path: ..."
      // on every flip frame. That inline `display: block` beats any
      // class-based `display: grid` we put on the page itself. So the
      // grid layout has to live on an INNER wrapper, not on .printova-book-page--opening.
      const inner = document.createElement('div');
      inner.className = 'printova-book-page__inner';

      const titleEl = document.createElement('h2');
      titleEl.className = 'printova-book-page__trip-title';
      titleEl.textContent = title || '';
      inner.appendChild(titleEl);

      const photoWrap = document.createElement('div');
      photoWrap.className = 'printova-book-page__opening-photo';
      const img = document.createElement('img');
      img.alt = '';
      photoWrap.appendChild(img);
      inner.appendChild(photoWrap);

      if (description && description.length > 0) {
        const descEl = document.createElement('p');
        descEl.className = 'printova-book-page__trip-desc';
        descEl.textContent = description;
        inner.appendChild(descEl);
      }

      pageEl.appendChild(inner);
    }

    pageLabel(idx) {
      const page = this.pages[idx];
      if (!page) return '';
      if (page.type === 'cover') return 'Cover';
      if (page.type === 'cover-back') return 'Back cover';
      if (page.type === 'opening') return 'Opening';
      const bookPage = this.coverUrl ? idx : idx + 1;
      return String(bookPage);
    }

    positionLabel(idx) {
      const page = this.pages[idx];
      if (!page) return '';
      if (page.type === 'cover') return 'Cover';
      if (page.type === 'cover-back') return 'Back cover';
      if (page.type === 'opening') return `Opening page • 1 of ${this.photoPageCount}`;
      const bookPage = this.coverUrl ? idx : idx + 1;
      return `Page ${bookPage} of ${this.photoPageCount}`;
    }

    initPageFlip(Lib) {
      if (this.pageFlip) {
        console.warn(
          '[printova-book-preview] initPageFlip skipped — pageFlip already initialized.'
        );
        return;
      }
      console.log('[printova-book-preview] initPageFlip start', {
        bookExists: !!this.book,
        pageElementsCount: this.pageElements ? this.pageElements.length : 0,
      });

      this.book.innerHTML = '';
      this.book.classList.remove('stf__parent');

      this.pageFlip = new Lib(this.book, {
        width: 380,
        height: 537,
        size: 'stretch',
        minWidth: 240,
        maxWidth: 560,
        minHeight: 339,
        maxHeight: 792,
        drawShadow: true,
        flippingTime: 700,
        maxShadowOpacity: 0.5,
        showCover: false,
        mobileScrollSupport: true,
        swipeDistance: 20,
        useMouseEvents: true,
      });

      console.log('[printova-book-preview] calling loadFromHTML', {
        items: this.pageElements.length,
      });
      this.pageFlip.loadFromHTML(this.pageElements);

      console.log('[printova-book-preview] after loadFromHTML', {
        bookChildren: this.book.children.length,
        domPageCount: document.querySelectorAll('.printova-book-page').length,
      });

      this.pageFlip.on('flip', (e) => {
        const pageNum = typeof e.data === 'number' ? e.data : 0;
        const visiblePages = Array.from(this.book.querySelectorAll('.printova-book-page'))
          .filter((p) => p.style.display !== 'none');
        console.log('[printova-book-preview] flip event', {
          newPage: pageNum,
          totalPagesInDOM: this.book.querySelectorAll('.printova-book-page').length,
          visiblePages: visiblePages.length,
          visiblePageIndices: visiblePages.map((p) => p.dataset.pageIndex),
        });
        this.position.textContent = this.positionLabel(pageNum);
        this.promoteLazy(pageNum);
      });

      this.position.textContent = this.positionLabel(0);
      this.promoteLazy(0);
      this._opening = false;
    }

    promoteLazy(currentPage) {
      const indices = [currentPage - 1, currentPage, currentPage + 1, currentPage + 2, currentPage + 3];
      indices.forEach((idx) => {
        if (idx < 0 || idx >= this.pages.length) return;
        const page = this.book.querySelector(`[data-page-index="${idx}"]`);
        if (!page) return;
        const img = page.querySelector('img');
        if (img && img.dataset.src) {
          img.src = img.dataset.src;
          delete img.dataset.src;
        }
      });
    }

    cropUrl(photo, width) {
      const base = `https://res.cloudinary.com/${this.cloudName}/image/upload`;
      const delivery = `q_auto,f_auto,w_${width}`;
      if (!photo.crop || photo.crop.auto) {
        return `${base}/c_fill,g_auto,ar_1000:1414/${delivery}/${photo.publicId}`;
      }
      const { x, y, width: w, height: h } = photo.crop;
      const fmt = (n) => Number(n).toFixed(4);
      return `${base}/c_crop,x_${fmt(x)},y_${fmt(y)},w_${fmt(w)},h_${fmt(h)}/c_fill,ar_1000:1414/${delivery}/${photo.publicId}`;
    }

    fadeLoader() {
      if (this.loaderFaded) return;
      this.loaderFaded = true;
      this.loader.style.transition = 'opacity 250ms ease';
      this.loader.style.opacity = '0';
      setTimeout(() => {
        this.loader.hidden = true;
      }, 300);
      clearTimeout(this._fallbackTimer);
    }

    close() {
      // NB: do NOT call this.pageFlip.destroy() — internally it calls
      // this.block.remove() which detaches our [data-book] element from
      // the DOM, breaking subsequent reopens.
      this.pageFlip = null;
      this._opening = false;
      this.book.innerHTML = '';
      this.book.classList.remove('stf__parent');
      this.book.removeAttribute('style');
      this.pageElements = [];
      this.removeAttribute('open');
      unlockBodyScrollPreview();
      document.removeEventListener('keydown', this._onKey);
      clearTimeout(this._fallbackTimer);
      this.loaderFaded = false;
      if (this._lastFocus && typeof this._lastFocus.focus === 'function') {
        this._lastFocus.focus();
      }
    }
  }

  customElements.define('printova-book-preview', PrintovaBookPreview);
}
